<template>
	<div class="goods">
	 <v-head :title="title"></v-head>
		<div class="signUp">
			<form id="signForm">
				<div v-for="groupType in groupTypeList" :key="groupType.name">
					<h4 v-if="groupType.fieldList && groupType.fieldList.length > 0">{{groupType.name}}</h4>
					<ul v-if="groupType.fieldList && groupType.fieldList.length > 0" class="inc">
						<template v-for="(item,index) in settingDetail">
							<template v-if="item.display && item.fieldCaption != null && item.groupType == groupType.value">
	<!--							时间选择器-->
								<template v-if="item.editorType==3">
									<van-popup v-model="whetherToShow" :key="index" label="" position="bottom">
										<van-datetime-picker
												:key="index"
												v-model="currentTime"
												type="date"
												@confirm="confirmDate(item.field)"
										/>
									</van-popup>
									<van-cell-group :key="index">
										<van-field :label="item.fieldCaption" 
										@click="showDateTime" v-model = "registerForm[item.field]" :placeholder="item.fieldCaption" />
									</van-cell-group>
								</template>
	<!--							单选按钮控件-->
								<template v-if="item.editorType == 5">
									<van-radio-group v-model="registerForm[item.field]" :key="index">
										<van-radio name="1">是</van-radio>
										<van-radio name="2">不是</van-radio>
									</van-radio-group>
								</template>
	<!--							性别单选按钮-->
								<template v-if="item.editorType == 2">
									<van-radio-group v-model="registerForm[item.field]" :key="index">
										<van-radio name="1">男</van-radio>
										<van-radio name="2">女</van-radio>
									</van-radio-group>
								</template>

	<!--							单行文本框-->
								<template v-if="item.editorType==1">
									<van-cell-group :key="index">
										<van-field  :label="item.fieldCaption"
										v-model = "registerForm[item.field]" :placeholder="item.fieldCaption" />
									</van-cell-group>
								</template>

	<!--							下拉列表选择框-->
								<template v-if="item.editorType==4">
									<van-dropdown-menu :key="index">
										<van-dropdown-item v-model="registerForm[item.field]" 
										:options="fieldDictionary(item.dictionaryId,item.fieldCaption)" />
<!--										<van-dropdown-item  ref="item"  @open="openMenu">-->
<!--											<div v-for="op in fieldDictionary(item.dictionaryId)" :key="op.name">-->
<!--												<van-switch-cell v-model="op.value" :title="op.name" />-->
<!--												<van-dropdown-item v-model="value" :options="fieldDictionary(item.dictionaryId)" />-->

<!--											</div>-->
<!--											<van-dropdown-item v-model="registerForm[item.field]" :options="fieldDictionary(item.dictionaryId)" />-->
<!--										</van-dropdown-item>-->
									</van-dropdown-menu>
								</template>

							</template>
						</template>
					</ul>
				</div>
			</form>
		</div>
				<div class="vanButton">
				  <van-button type="primary" @click="submitSignDialog">提交</van-button>
				</div>
	</div>
</template>
<script>
import {getMeetingSettings,getDictionary,getCurrentAccount,getRegisterForm,registerMeeting,getUserInfoByNameMobile,registerUser,getMeetingPlaces} from "@/api/dictionary";
import {getSessionStore} from "@/utils/sessionStorage.js"
import { Field ,CellGroup ,DatetimePicker ,RadioGroup, Radio ,DropdownMenu, DropdownItem,SwitchCell,Button ,Toast,Popup} from "vant";
import { mapGetters ,mapMutations} from "vuex";
import "../../static/jquery-1.10.2";
import vHead from "../../components/Subhead.vue";
export default {
  data() {
    return {
		registerForm:[],//报名表单值
		settingDetail:[],//按报名分类
		whetherToShow:false,//是否展示时间选择器
		currentTime:new Date(),//当前时间
		title:"报名表",
		places:[]
    };
  },
  components: {
  vHead,
  	[Field.name]:Field,
	[CellGroup.name]:CellGroup,
	[DatetimePicker.name]:DatetimePicker,
	[RadioGroup.name]:RadioGroup,
	[Radio.name]:Radio,
	[DropdownMenu.name]:DropdownMenu,
	[DropdownItem.name]:DropdownItem,
	[SwitchCell.name]:SwitchCell,
	[Button.name]:Button,
	[Toast.name]:Toast,
	[Popup.name]:Popup, 

  }, 
  methods: {
	  ...mapMutations(["setDictionary"]),
	  getData() {
		  getMeetingPlaces({ meetingId: this.meetingId }).then(resp => {
			  if (resp.success) {
			  	let options = [];
			  	  // options.push({text:"会场选择",value:"abcdefg"});
			  	  // this.registerForm[placeId] = "abcdefg";
				  resp.result.filter(item=> {
					  options.push({text: item.name, value: item.id});
				  });
				  this.places = options;
				  this.places.map(item => (item.value = item.id));
			  }
		  });
		  getMeetingSettings({ meetingId: this.meetingId })
				  .then(resp => {
					  if (resp.success) {
						  this.settingDetail = resp.result;
					  }
				  })
				  .catch(() => {
					  // this.$message.error("获取报名设置失败！");
				  });
	  },
		getDictionarys() {
				getDictionary({
					tid: 0
				}).then(res => {
					if (res.success) {
						this.setDictionary(res.result);
					}
				});
		},
	  getStatus() {
		  let token = getSessionStore("access_token");
		  if (token) {
			  getCurrentAccount()
					  .then(resp => {
						  if (resp.success) {
							  this.memberId = resp.result.id;
							  this.account = resp.result;
							  getRegisterForm({"access_token":token}).then(resp => {
								  if (resp.success) {
									  this.registerForm = resp.result;
									  this.getData();
								  }
							  });
						  }
					  })
					  .catch(err => {
					  });
		  }
	  },
	  dateFormat(timeStamp) {
		  let year = new Date(timeStamp).getFullYear();
		  let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
		  let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
		  return year + "-" + month + "-" + date;
	  },
		timeFormate(timeStamp) {
			let year = new Date(timeStamp).getFullYear();
			let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
			let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
			let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
			let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
			let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
			return year + "-" + month + "-" + date+" "+hh+":"+mm +":"+ss;
		},
	  submitSignDialog() {

		  let self = this;
		  let sendData = {};
		  let formData = jQuery("#signForm").serializeArray();
		  formData.forEach(function(item) {
			  sendData[item.name] = item.value;
		  });
		  sendData.meetingId = self.meetingId;
		  // sendData.paperFileId = self.uploadFileId;
		  let errorItem = undefined;
		  for (let item of self.settingDetail) {
			  if (item.display) {
				  if (self.$refs[item.field])
					  self.$refs[item.field][0].classList.remove("error");
				  if (!item.nullable) {
					  if (!sendData[item.field] && self.$refs[item.field]) {
						  self.$refs[item.field][0].classList.add("error");
						  errorItem = item;
						  break;
					  }
				  }
				  if (item.editorType == 3) {
					  if (item.field != "birthday") {
						  sendData[item.field] = this.timeFormate(this.registerForm[item.field]);
					  }
				  }
			  }
		  }
		  if (errorItem) {
			  alert("请填写必填项目：" + errorItem.fieldCaption);
			  //回到顶端
			  $(".bg_block").scrollTop(0);
			  return false;
		  }
		  sendData = Object.assign({}, this.registerForm, sendData);
		  if (!sendData.extentions) {
			  delete sendData.extentions;
		  }

		  if(sendData.memberCategory == undefined){
			  sendData.memberCategory = 9;
		  }
		  //无用户  去注册

		  let da ={
			  name: sendData.name,
			  mobile: sendData.mobile
		  }
		  getUserInfoByNameMobile(da)
				  .then(resp => {
					  if(resp.messageCode === '10011'){
						  let params = {
							  mobile: sendData.mobile,
							  email: sendData.email,
							  name: sendData.name,
							  birthday : sendData.birthday,
							  gender: sendData.gender,
							  fullAddress: sendData.fullAddress,
							  major: sendData.major,
							  education: sendData.education,
							  zipcode: sendData.zipcode,
							  company: sendData.company
						  }

						  registerUser(params)
								  .then(resp => {
									  //设置会员memberid

									  sendData.memberId = resp.result.id;
									  registerMeeting(sendData)
											  .then(resp => {
												  if (resp.success) {
													  this.$router.push({path:"/MeetingDetails",query:{"meetingId":this.meetingId}});
												  } else if (resp.message) {
													  Toast.fail(resp.message);
												  }
											  })
											  .catch(err => {
												  Toast.fail("表单提交失败");
											  });
								  })
					  }else{
						  registerMeeting(sendData)
								  .then(resp => {
									  if (resp.success) {
										  this.$router.push({path:"/MeetingDetails",query:{"meetingId":this.meetingId}});
									  } else if (resp.message) {
										  Toast.fail(resp.message);
									  }
								  })
								  .catch(err => {
									  Toast.fail("表单提交失败");
								  });
					  }
				  })
	  },
	  confirmDate(field){//确定
	  	let date = this.dateFormat(this.currentTime);
	  	this.registerForm[field] = date;
	  	this.whetherToShow = false;
	  },
	  showDateTime(){
			this.whetherToShow = true;
	  },
  },
	computed:{
		groupTypeList() {
			let dict = this.dictFromCode("INFO_GROUP");
			dict.map(item => {
				item.fieldList = this.settingDetail.filter(
						field => field.groupType == item.value
				);
			});
			return dict;
		},
		fieldDictionary() {
			return (code,filedName) => {
				if ("MEETING_PLACE" == code) {
					return this.places;
				} else {
					if(this.dictFromCode(code).length>0){
						let options = [];
						options.push({text:filedName});
						this.dictFromCode(code).filter(item=>{
							options.push({text:item.name,value:item.value})
						});
						return options;
					}else {
						return  [];
					}
				}
			};
		},
		meetingId(){
			return this.$route.query&&this.$route.query.meetingId;
		},
		...mapGetters(["dictFromCode"])
	},
	mounted() {
		this.getDictionarys();
		this.getStatus();
	}
};
</script>

<style  lang="less" scoped>
.imgBox{ 
	padding:20px; 
    img{ width: 100%; }
}	
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
/deep/.van-cell-group{ margin-top: -1px; }
.content{ padding:0 15px;}
.content li{ padding:15px 0; border-bottom: #dfdfdf solid 1px; }
.content li p{ line-height:25px; overflow: hidden;}
.content li p span{ display: block; float: left; width:20%; text-align: right; }
.content li p font{ display: block; float: left; width:80%; }
.download{ text-align: right;
	.van-button{ height: 40px; line-height: 30px; }
}
.red{ color: #e12121; }
.signUp{ background: #f3f3f3; }
.signUp h4{ padding: 15px 0; font-size:16px; padding-left: 15px; }
.vanButton{ text-align: center; margin: 35px 0;}
.vanButton .van-button{ width: 90%; }
/deep/.van-dropdown-menu__item{ display: block!important; width: 100%; }
/deep/.van-ellipsis{ display: inline-block; line-height: 50px;color: #dfdfdf;}
/deep/.van-dropdown-menu__title::after{ top: -12px; }
/deep/.van-nav-bar__text{color: #dfdfdf;}
</style>